import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from "./pages/HomePage";
import {PrivacyPolicyPage} from "./pages/PrivacyPolicyPage";
import {TermsOfServicePage} from "./pages/TermsOfServicePage";
import {ContactPage} from "./pages/ContactPage";
import {LanguageProvider} from "./context/LanguageContext";
import './landing.css';
import ThankYouPage from './pages/ThankYouPage';

function App() {
    return (
        <LanguageProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/thank-you" element={<ThankYouPage />} />
                </Routes>
            </Router>
        </LanguageProvider>
    );
}

export default App;
